import { type LogicalOperator } from "../../types/FilterTable";

export const OPERATOR_OR: LogicalOperator = "OR";
export const OPERATOR_AND: LogicalOperator = "AND";
